import React, { useEffect, useState } from 'react';
import api from '../../../config/axiosConfig'

const AccountsList = () => {
    const [accounts, setAccounts] = useState([]);

    useEffect(() => {
        const fetchAccounts = async () => {
            const response = await api('/accounts'); // Adjust the URL
            setAccounts(response.data);
        };
        fetchAccounts();
    }, []);

    return (
        <div>
            {accounts.map((account) => (
                <div key={account.id}>
                    <h2>{account.name}</h2>
                    <p>ID Proof Number: {account.idProofNumber}</p>
                    {account.idProofDocument && (
                        <img
                            src={`${process.env.REACT_APP_WS_URL}${account.idProofDocument}`}
                            alt="ID Proof"
                            style={{ width: '100px', height: 'auto' }}
                        />
                    )}
                </div>
            ))}
        </div>
    );
};

export default AccountsList;
